/*--------------------------------------------------------------
# Custom scripts for Columns Content Block
--------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
    // Check if there are any .card--complex elements on the page
    const cardComplexes = document.querySelectorAll('.card--complex');
    if (cardComplexes.length === 0) return; // Exit if none found

    function setTranslateBasedOnCardBody() {
        if (window.innerWidth < 992) {
            // Reset any applied transform styles if the screen is below 992px
            cardComplexes.forEach(card => {
                let heading = card.querySelector('.wp-block-heading');
                if (heading) {
                    heading.style.transform = ''; 
                }
            });
            return;
        }

        // Loop through each .card--complex
        cardComplexes.forEach(card => {
            let cardBody = card.querySelector('.card-body');
            if (cardBody) {
                let cardBodyHeight = cardBody.offsetHeight;
                let heading = card.querySelector('.wp-block-heading');

                if (heading) {
                    let headingHeight = heading.offsetHeight;
                    let translateY = cardBodyHeight - headingHeight;

                    heading.style.transform = `translate(0, calc(${translateY}px - 14px))`;
                }
            }
        });
    }

    // Run on page load
    setTranslateBasedOnCardBody();

    // Throttle resize event
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(setTranslateBasedOnCardBody, 150);
    });
});
